import { StorageType } from '@/interfaces/storage'
import { StorageImpl } from './storage'
import { MockStorage } from '@/services/storage/mockStorage'

export class StorageFactory {
  public static getStorage(type: StorageType) {
    if (typeof window === 'undefined') {
      return new StorageImpl(new MockStorage())
    }

    switch (type) {
      case StorageType.LOCAL:
        return new StorageImpl(localStorage)
      case StorageType.SESSION:
        return new StorageImpl(sessionStorage)
      default:
        return new StorageImpl(localStorage)
    }
  }
}
